import React, { Component } from 'react';
import { MessageBox } from '@eg/elements/MessageBox';

import './PrivacyInformation.scss';

class PrivacyInformation extends Component {
  render() {
    return (
      <MessageBox id="privacyInformation" padding="normal">
        Bei der Verarbeitung von personenbezogenen Daten beachten wir die Vorschriften der EU-Datenschutz-Grundverordnung.
        Ausführliche Informationen finden Sie im <a href="https://www.ergo.de/de/Service/Datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzbereich</a> unserer Webseite.
      </MessageBox>
    )
  }
}

export default PrivacyInformation;
